export default "__VITE_ASSET__693e8017__"